import React, { useContext, useEffect, useState } from 'react'
import MainNav from '../../Components/Navbar'
import { getDatabase, onValue, ref, get } from 'firebase/database';
import GlobalContext from '../../Components/GlobalContext';
import { Container, Spinner, Table, OverlayTrigger, Tooltip, Pagination, Alert } from 'react-bootstrap';
import { firebaseToString } from '../../Tools/tools';
import { useNavigate } from 'react-router';
import LogoQualy from '../../Components/LogoQualy';
import CustomSelect from '../../Components/CustomSelect';
import { exportContentExcel } from '../../Components/ExcelUtils';
import { selectFile, downloadAllFiles, uploadFile } from '../../Components/oneDrive';
import useCompanies from "../../hooks/useCompanies";
import useRolls from "../../hooks/useRolls";

function Presencas() {

    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
    const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()));
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const currentYear = new Date().getFullYear();
    const [uploading, setUploading] = useState(false);
    const startYear = 2024;
    const [isDownloading, setIsDownloading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);
    const [isFiltering, setIsFiltering] = useState(false);
    const { companyNames, allCompanies } = useCompanies();
    const { globalData } = useContext(GlobalContext);
    const {
        rawData,
        rawRows,
        roll,
        filteredRows,
        selectedCompany,
        setSelectedCompany,
        isInitialLoading,
        setFilteredRows,
        setRoll,
    } = useRolls(globalData);

    const db = getDatabase()
    const navigate = useNavigate()

    //filtragem de resultados baseando-se nos filtros aplicados
    function filterResults() {
        setIsFiltering(true);

        try {
            const targetYear = parseInt(selectedYear);
            const targetMonth = selectedMonth ? parseInt(selectedMonth) : null;


            const filtered = rawRows.filter(row => {
                if (selectedCompany && row.company !== selectedCompany) {
                    return false;
                }

                if (selectedDepartment && row.department !== selectedDepartment) {

                    return false;
                }

                const rowYear = parseInt(row.year);
                const rowMonth = parseInt(row.month);

                if (rowYear !== targetYear) {
                    return false;
                }

                if (targetMonth !== null && rowMonth !== targetMonth) {
                    return false;
                }

                return true;
            });

            if (filtered.length === 0) {
                alert("Nenhum registro encontrado para os critérios selecionados.");
                setSelectedDepartment('');
                setSelectedMonth(String(new Date().getMonth() + 1).padStart(2, '0'));
                setSelectedYear(String(new Date().getFullYear()));
                setRoll(globalData.role === 'admin' ? rawRows : rawRows.filter(row => row.company === globalData.company));
                setFilteredRows(globalData.role === 'admin' ? rawRows : rawRows.filter(row => row.company === globalData.company));
                return;
            }

            setFilteredRows(filtered);
            setRoll(filtered);
        } finally {
            setIsFiltering(false);
        }
    }

    //baixa do onedrive caso tiver arquivo se nao baixa do banco mesmo
    const handleDownload = async () => {
        if (!selectedCompany || !selectedMonth || !selectedYear) {
            alert("Selecione empresa, mês e ano antes de baixar um arquivo.");
            return;
        }

        try {
            setIsDownloading(true);

            const count = await downloadAllFiles(
                globalData.apiHost,
                selectedCompany,
                selectedDepartment || "GERAL",
                selectedYear,
                selectedMonth,
                process.env.REACT_APP_BACKEND_SECRET
            );

            if (count === 0) {
                await exportContentExcel(
                    selectedCompany,
                    selectedDepartment,
                    selectedMonth,
                    selectedYear,
                    allCompanies,
                    roll,
                    getRollData,
                    rawData,
                    firebaseToString
                );
            }

        } catch (error) {
            if (error.message.includes("Nenhum arquivo encontrado")) {
                await exportContentExcel(
                    selectedCompany,
                    selectedDepartment,
                    selectedMonth,
                    selectedYear,
                    allCompanies,
                    roll,
                    getRollData,
                    rawData,
                    firebaseToString
                );
            } else {
                alert(`Erro ao baixar: ${error.message}`);
            }
        } finally {
            setIsDownloading(false);
        }
    };

function getRollData(rollsRemodelData, companyName, depName, datetime, selectedYear, selectedMonth) {
    if (!rollsRemodelData || !companyName || !depName) {
        return null;
    }

    try {
        const monthKey = selectedMonth.replace(/^0/, '');
        const sessionData = rollsRemodelData?.[selectedYear]?.[monthKey]?.[companyName]?.[depName]?.[datetime] || null;
        if (sessionData) return sessionData;
    } catch (error) {}

    let year, month;
    if (datetime && datetime.includes('-')) {
        const dateParts = datetime.split('-');
        if (dateParts.length >= 3) {
            year = dateParts[2];
            month = dateParts[1];
        }
    }

    year = year || selectedYear;
    month = month || selectedMonth;

    if (!year || !month) {
        return null;
    }

    try {
        const monthKey = month.replace(/^0/, '');
        const sessionData = rollsRemodelData?.[year]?.[monthKey]?.[companyName]?.[depName]?.[datetime] || null;
        return sessionData;
    } catch (error) {
        return null;
    }
}
const Detalhado = async (uid, department, professor, company, dateTime, originalTime) => {
    const [day, month, year, time] = originalTime.split(/[-:]/);
    const yearKey = year;
    const monthKey = month.replace(/^0+/, '');

    try {
        const rollRef = ref(db, `rolls_remodel/${yearKey}/${monthKey}/${company}/${department}/${dateTime}`);
        const snapshot = await get(rollRef);

        if (snapshot.exists()) {
            const rollData = snapshot.val();
            navigate('detalhado', {
                state: {
                    roll: rollData,
                    department: firebaseToString(department),
                    professor: professor,
                    company: firebaseToString(company),
                    dateTime: dateTime,
                    print: false,
                    rawRollData: rollData
                }
            });
        } else {
            console.log("Chamada não encontrada no Firebase");
        }
    } catch (error) {
        console.error("Erro ao buscar dados detalhados:", error);
    }
};
    useEffect(() => {
        if (globalData.role !== 'admin' && globalData.company) {
            setSelectedCompany(globalData.company);
            const companyData = allCompanies[globalData.company];
            if (companyData) {
                const deps = Object.entries(companyData)
                    .filter(([key, value]) =>
                        key !== 'isCompanyVisible' &&
                        key !== 'instrutores' &&
                        typeof value === 'object' &&
                        value.isDeptVisible === true
                    )
                    .map(([key]) => key);

                const formatted = deps.map(dep => ({
                    value: dep,
                    label: firebaseToString(dep),
                }));
                setDepartmentOptions(formatted);
            }
        }
    }, [globalData, allCompanies]);
    const [filteredSessions, setFilteredSessions] = useState([]);

    useEffect(() => {
        if (!selectedCompany) {
            setFilteredSessions([]);
            return;
        }

        const processSessionDate = (numberedday, dias) => {
            try {
                const fixedDateStr = numberedday.replace(' ', 'T');
                const originalDate = new Date(fixedDateStr);

                const modifiedDate = new Date(originalDate);
                modifiedDate.setDate(modifiedDate.getDate() + 7);

                const formatDate = (date) => {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    return `${day}/${month}/${date.getFullYear()}`;
                };

                const formattedOriginal = formatDate(originalDate);
                const formattedModified = formatDate(modifiedDate);

                const diasValues = dias ? Object.values(dias) : [];
                const wasCalled = diasValues.includes(formattedModified);

                return {
                    originalDate: formattedOriginal,
                    modifiedDate: formattedModified,
                    wasCalled,
                    callStatus: wasCalled ? 'Chamada realizada' : 'Chamada pendente',
                    diasValues
                };
            } catch (e) {
                return {
                    originalDate: numberedday,
                    modifiedDate: "Data inválida",
                    wasCalled: false,
                    callStatus: "Data inválida",
                    diasValues: []
                };
            }
        };

        const sessionsRef = ref(db, '/sessions/');
        const unsubscribe = onValue(sessionsRef, (snapshot) => {
            const allSessions = snapshot.val() || {};
            const sessions = [];

            Object.entries(allSessions).forEach(([userId, userData]) => {
                if (!userData?.[selectedCompany]) return;

                Object.entries(userData[selectedCompany]).forEach(([department, deptData]) => {
                    if (!deptData) return;

                    const daysOfWeek = ['Segunda-feira', 'Terça-feira', 'Quarta-feira',
                        'Quinta-feira', 'Sexta-feira'];

                    daysOfWeek.forEach(weekday => {
                        const dayData = deptData[weekday];
                        if (!dayData) return;

                        const sessionId = Object.keys(dayData).find(key => key.startsWith('-'));
                        const sessionData = sessionId ? dayData[sessionId] : dayData;

                        if (sessionData?.numberedday) {
                            const dateInfo = processSessionDate(
                                sessionData.numberedday,
                                sessionData.dias
                            );

                            sessions.push({
                                userId,
                                company: selectedCompany,
                                department,
                                weekday,
                                ...dateInfo,
                                sessionId: sessionId || 'root'
                            });


                        }
                    });
                });
            });

            setFilteredSessions(sessions);
        });

        return () => unsubscribe();
    }, [selectedCompany]);

    return (
        <>
            <MainNav />
            <div className=''>
                <Container className='w-100 pt-3' style={{ minHeight: "90vh" }}>
                    <div className="mb-3 d-flex flex-wrap">

                        {/*filtros, este primeiro aparece exclusivamente se a pessoa for admin*/}
                        {globalData.role === 'admin' && (
                            <CustomSelect
                                options={companyNames
                                    .filter((name) => name !== 'id')
                                    .map((name) => ({ value: name, label: firebaseToString(name) }))}
                                value={selectedCompany}
                                onChange={(e) => {
                                    const companyValue = e.target.value;
                                    setSelectedCompany(companyValue);
                                    setSelectedDepartment('');
                                    const companyData = allCompanies[companyValue];


                                    if (companyData) {
                                        const deps = Object.entries(companyData)
                                            .filter(([key, value]) => {
                                                return (
                                                    key !== 'isCompanyVisible' &&
                                                    key !== 'instrutores' &&
                                                    value?.isDeptVisible === true
                                                );
                                            })
                                            .map(([key]) => key);

                                        setDepartmentOptions(
                                            deps.map(dep => ({ value: dep, label: firebaseToString(dep) }))
                                        );
                                    } else {
                                        setDepartmentOptions([]);
                                    }

                                }}
                                placeholder="Empresa"
                                ariaLabel="select-company"
                                className='me-3'
                                style={{ width: '300px' }}
                            />
                        )}

                        <CustomSelect
                            options={departmentOptions}
                            value={selectedDepartment}
                            onChange={(e) => setSelectedDepartment(e.target.value)}
                            placeholder="Departamento"
                            ariaLabel="select-department"
                            className='me-3'
                            style={{ width: '200px' }}
                        />

                        <CustomSelect
                            options={Array.from({ length: 12 }, (_, i) => {
                                const value = String(i + 1).padStart(2, '0');
                                const label = new Date(0, i).toLocaleString('pt-BR', { month: 'long' });
                                return { value, label: label.charAt(0).toUpperCase() + label.slice(1) };
                            })}
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            placeholder="Mês"
                            ariaLabel="select-month"
                            className="me-3"
                            style={{ width: '120px' }}
                        />

                        <CustomSelect
                            options={Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
                                const year = startYear + i;
                                return { value: String(year), label: String(year) };
                            })}
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            placeholder="Ano"
                            ariaLabel="select-year"
                            className='me-3'
                            style={{ width: '80px' }}
                        />

                        {/*botões de ação */}
                        <OverlayTrigger overlay={<Tooltip>Filtra os dados conforme os critérios selecionados</Tooltip>}>
                            <button className="btn btn-primary me-3" style={{ height: '38px' }} onClick={filterResults}>
                                Filtrar
                            </button>
                        </OverlayTrigger>

                        {globalData.role === 'admin' && (
                            <>
                                <OverlayTrigger overlay={<Tooltip>Exporta os dados filtrados para uma planilha Excel</Tooltip>}>
                                    <button
                                        className="btn btn-primary me-3"
                                        style={{ height: '38px' }}
                                        onClick={() => exportContentExcel(
                                            selectedCompany,
                                            selectedDepartment,
                                            selectedMonth,
                                            selectedYear,
                                            allCompanies,
                                            roll,
                                            getRollData,
                                            rawData,
                                            firebaseToString
                                        )}
                                        disabled={!selectedCompany || !selectedMonth || filteredRows.length === 0}
                                    >
                                        Salvar
                                    </button>
                                </OverlayTrigger>

                                <OverlayTrigger overlay={<Tooltip>Carrega no banco de dados um arquivo para o mês selecionado</Tooltip>}>
                                    <button
                                        className="btn btn-primary me-3"
                                        style={{ height: '38px' }}
                                        disabled={filteredRows.length === 0 || uploading}
                                        onClick={async () => {
                                            try {
                                                if (!selectedCompany || !selectedMonth || !selectedYear) {
                                                    alert("Selecione empresa, mês e ano antes de carregar um arquivo.");
                                                    return;
                                                }
                                                const file = await selectFile();
                                                setUploading(true);
                                                await uploadFile(
                                                    globalData.apiHost,
                                                    file,
                                                    selectedCompany,
                                                    selectedDepartment || "GERAL",
                                                    selectedYear,
                                                    selectedMonth,
                                                    process.env.REACT_APP_BACKEND_SECRET
                                                );
                                                alert(`Arquivo ${file.name} enviado com sucesso!`);
                                            } catch (error) {
                                                alert(error.message || "Erro no upload.");
                                            } finally {
                                                setUploading(false);
                                            }
                                        }}
                                    >
                                        {uploading ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Enviando...
                                            </>
                                        ) : (
                                            "Upload"
                                        )}
                                    </button>
                                </OverlayTrigger>

                            </>
                        )}

                        <OverlayTrigger overlay={<Tooltip>Baixa do banco de dados as planilhas do mês selecionado</Tooltip>}>
                            <button
                                className="btn btn-primary me-3"
                                style={{ height: '38px' }}
                                onClick={handleDownload}
                                disabled={!selectedCompany || !selectedMonth || !selectedYear || isDownloading || filteredRows.length === 0}
                            >
                                {isDownloading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Baixando...
                                    </>
                                ) : (
                                    "Download"
                                )}
                            </button>
                        </OverlayTrigger>
                    </div>

                    {uploading && (
                        <Alert variant="info" className="d-flex align-items-center mt-2">
                            <Spinner animation="border" size="sm" className="me-2" />
                            Enviando arquivo...
                        </Alert>
                    )}

                    {(isInitialLoading || isFiltering) ? (
                        <div className="d-flex flex-column justify-content-center align-items-center w-100" style={{ textAlign: "center", minHeight: "60vh" }}>
                            <div>
                                <LogoQualy className="w-100" />
                            </div>
                            <div className="mt-3">
                                <Spinner animation="border" />
                            </div>
                        </div>
                    ) : (
                        <>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Nome do Professor</th>
                                        <th className='d-none d-md-table-cell'>Empresa</th>
                                        <th className='d-none d-md-table-cell'>Departamento</th>
                                        <th className='d-table-cell d-md-none'>Empresa e Departamento</th>
                                        <th>Registro da Chamada</th>
                                        <th>Horário da Aula</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roll
                                        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                                        .map((row, index) => (
                                            <tr key={index} style={{ cursor: "pointer" }} onClick={() => {
                                                Detalhado(row.uid, row.department, row.instructor, row.company, row.keyDate, row.originalTime);
                                            }}>
                                                <td>{row.instructor}</td>
                                                <td className='d-none d-md-table-cell'>{firebaseToString(row.company)}</td>
                                                <td className='d-none d-md-table-cell'>{firebaseToString(row.department)}</td>
                                                <td className='d-table-cell d-md-none'>{firebaseToString(row.company)} - {firebaseToString(row.department)}</td>
                                                <td>{row.dateTime.toLocaleDateString()} {row.dateTime.toLocaleTimeString()}</td>
                                                <td>
                                                    {(() => {
                                                        const [day, month, year, time] = row.originalTime.split('-');
                                                        return `${day}/${month}/${year} ${time}`;
                                                    })()}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-center mt-3">
                                <Pagination>
                                    <Pagination.Prev
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                    />
                                    {(() => {
                                        const totalPages = Math.ceil(roll.length / itemsPerPage);
                                        const maxVisiblePages = 5;
                                        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                                        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                                        if (endPage - startPage + 1 < maxVisiblePages) {
                                            startPage = Math.max(1, endPage - maxVisiblePages + 1);
                                        }
                                        const pages = [];
                                        for (let i = startPage; i <= endPage; i++) {
                                            pages.push(
                                                <Pagination.Item
                                                    key={i}
                                                    active={i === currentPage}
                                                    onClick={() => setCurrentPage(i)}
                                                >
                                                    {i}
                                                </Pagination.Item>
                                            );
                                        }
                                        return pages;
                                    })()}
                                    <Pagination.Next
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(roll.length / itemsPerPage)))}
                                        disabled={currentPage === Math.ceil(roll.length / itemsPerPage)}
                                    />
                                </Pagination>
                            </div>
                        </>
                    )}
                </Container>
            </div>
        </>
    );
}

export default Presencas;